/* eslint-disable */
import { v4 as uuidV4 } from 'uuid';
export class EventoAdministrativo {
  constructor () {
    this.evento_adm_id = uuidV4();
    this.descricao = '';
    this.plano_conta_id = ''
  }
}
